/*
 * MSE_NOTIFY_BUTTON_COMPACT_V1_20260918
 * Visual only.
 */

(() => {
  'use strict';

  const MARKER =
    'MSE_NOTIFY_BUTTON_COMPACT_V1_20260918';

  function normalize(value) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function apply() {
    const candidates =
      document.querySelectorAll(
        'button, a, input[type="button"], input[type="submit"]'
      );

    candidates.forEach((el) => {
      const text =
        normalize(
          el.tagName === 'INPUT'
            ? el.value
            : el.textContent
        );

      if (
        !text.includes(
          'informiere mich wenn wieder da'
        )
      ) {
        return;
      }

      if (
        el.dataset.mseNotifyCompact
        === MARKER
      ) {
        return;
      }

      el.dataset.mseNotifyCompact =
        MARKER;

      el.style.setProperty(
        'min-height',
        '48px',
        'important'
      );

      el.style.setProperty(
        'height',
        '48px',
        'important'
      );

      el.style.setProperty(
        'padding',
        '0 18px',
        'important'
      );

      el.style.setProperty(
        'font-size',
        '16px',
        'important'
      );

      el.style.setProperty(
        'font-family',
        'inherit',
        'important'
      );

      el.style.setProperty(
        'font-weight',
        '700',
        'important'
      );

      el.style.setProperty(
        'line-height',
        '1.2',
        'important'
      );

      el.style.setProperty(
        'text-transform',
        'none',
        'important'
      );

      el.style.setProperty(
        'letter-spacing',
        '0',
        'important'
      );

      el.style.setProperty(
        'background',
        '#6654b8',
        'important'
      );

      el.style.setProperty(
        'background-color',
        '#6654b8',
        'important'
      );

      el.style.setProperty(
        'color',
        '#ffffff',
        'important'
      );

      el.style.setProperty(
        'border',
        '1px solid #6654b8',
        'important'
      );

      el.style.setProperty(
        'border-radius',
        '6px',
        'important'
      );

      el.style.setProperty(
        'box-shadow',
        'none',
        'important'
      );

      el.style.setProperty(
        'white-space',
        'nowrap',
        'important'
      );

      el.style.setProperty(
        'display',
        'inline-flex',
        'important'
      );

      el.style.setProperty(
        'align-items',
        'center',
        'important'
      );

      el.style.setProperty(
        'justify-content',
        'center',
        'important'
      );
    });
  }

  function start() {
    apply();

    let timer = null;

    const observer =
      new MutationObserver(() => {
        clearTimeout(timer);

        timer =
          window.setTimeout(
            apply,
            80
          );
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState
    === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();